import React, { useEffect } from "react";
import { Col } from "react-bootstrap";
import { useMutation } from "@apollo/client";

import { FavoriteButton } from "components/FavoriteButton";
import { REMOVE_FAVORITE } from "../../schemas/favorite";

export const RemoveFavorite = ({ getAllFavorites, labels, item, fromProgramPage }) => {
const [ removeFavorite, { data: favoriteDataInfo, error: favoriteErrorInfo }, ] = useMutation(REMOVE_FAVORITE);

  const handleRemoveFavorite = (nid, e) => {
    e.preventDefault();
    removeFavorite({
      variables: {
        programInfo: {
          nid: Number(nid),
          langcode: item.langcode
        }
      },
    });
  };
  useEffect(() => {
    if (favoriteDataInfo) {
      getAllFavorites();
    }
  }, [favoriteDataInfo]);
  return (
    <Col xs={12} className="remove-favorites">
      <FavoriteButton
      addButton={ false }
      handleClick={ handleRemoveFavorite }
      fromProgramPage= { fromProgramPage }
      labels={ labels }
      item= { item }
      />
    </Col>
  );
};
